const TAB_BUTTON_RIGHT = 0;
const TAB_BUTTON_LEFT = 1;
const TAB_BUTTON_HOME = 2;
const TAB_BUTTON_END = 3;
const TAB_BUTTON_TAB = 4;
const TAB_BUTTON_ENTER = 5;
const TAB_BUTTON_SPACE = 6;
const TAB_BUTTON_CLICK = 7;
const TAB_LIST_UPDATED = 8;
const TAB_LIST_FOCUSED = 9;
const TAB_PANELS_UPDATED = 10;
const TAB_BUTTON_REGISTER = 11;
export {
  TAB_BUTTON_CLICK,
  TAB_BUTTON_END,
  TAB_BUTTON_ENTER,
  TAB_BUTTON_HOME,
  TAB_BUTTON_LEFT,
  TAB_BUTTON_REGISTER,
  TAB_BUTTON_RIGHT,
  TAB_BUTTON_SPACE,
  TAB_BUTTON_TAB,
  TAB_LIST_FOCUSED,
  TAB_LIST_UPDATED,
  TAB_PANELS_UPDATED
};
